<template>
    <div>
        <div v-if="zero_search_results || projects.length > 0" class="w-auto">
            <div class="flex flex-wrap flex-lg-nowrap lg:justify-between">
                <div class="text-2xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">Projects</div>

                <div class="w-full md:w-2/3 flex">
                    <div class="bg-grey-lighter rounded-full w-full xl:w-1/3 items-center">
                        <input ref="filter" type="search" dusk="search-by-name"
                               class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-2 rounded-full ml-3 text-sm"
                               placeholder="Search by name..." @input="debounceFilter" v-model="filter.project_name">
                        <div class="flex-1 text-right pr-3">
                            <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest"
                               aria-hidden="true"></i>
                        </div>
                    </div>

                    <button class="border-2 border-teal bg-teal font-semibold p-2 rounded-full text-white ml-1 xl:hidden"
                            id="responsiveDropdown" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-caret-down mx-2"></i>
                    </button>

                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="responsiveDropdown">

                        <hr class="md:hidden">
                        <h6 class="dropdown-header">
                            Mass Updates
                        </h6>
                        <button @click="updateAssignedUsersModal" class="dropdown-item">
                            Update Assigned Users
                        </button>
                        <button @click="updateMasterClientModal" class="dropdown-item">
                            Update Master Client
                        </button>
                        <hr>
                        <h6 class="dropdown-header">
                            Advanced Search
                        </h6>
                        <button class="dropdown-item" @click="show_advanced_search = !show_advanced_search">
                            Search Files
                        </button>
                        <button class="dropdown-item" @click="clearSearch">
                            Clear Search
                        </button>
                        <button v-if="current_search_pattern" class="dropdown-item" @click="saveSearchPatternModal">
                            Save Pattern
                        </button>
                        <button class="dropdown-item" @click.prevent.stop="useSavedSearchPatternModal">
                            Use Pattern
                        </button>
                    </div>

                    <button class="border-2 border-teal bg-teal font-semibold p-2 rounded-full text-white ml-1 hidden xl:inline"
                            id="saveSearchDropdown" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-save mx-2"></i>
                        <i class="fa fa-caret-down mx-2"></i>
                    </button>

                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="saveSearchDropdown">
                        <h6 class="dropdown-header">
                            Advanced Search
                        </h6>
                        <button v-if="current_search_pattern" class="dropdown-item"
                                @click="saveSearchPatternModal">
                            <i class="fa fa-fw text-left fa-btn fa-save text-grey"></i> Save Pattern
                        </button>
                        <button class="dropdown-item" @click.prevent.stop="useSavedSearchPatternModal">
                            <i class="fa fa-fw text-left fa-btn fa-search text-grey"></i> Use Pattern
                        </button>
                    </div>
                    <save-pattern ref="savePatternModal"></save-pattern>
                    <use-pattern ref="usePatternModal"
                                 v-on:use-pattern="(filter) => fetchProjects(filter)"></use-pattern>

                    <button @click="updateAssignedUsersModal"
                            class="hidden xl:inline border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white p-2 rounded-full text-sm text-followup-nav ml-1">
                        Update Assigned Users
                    </button>
                    <assigned-users ref="updateAssignedUsersModal" :checked_project_ids="checked_project_ids"
                                    v-on:update-finished="massUpdateFinished"></assigned-users>

                    <button @click="updateMasterClientModal"
                            class="hidden xl:inline border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white p-2 rounded-full text-sm text-followup-nav ml-1">
                        Update Master Client
                    </button>
                    <master-client ref="updateMasterClientModal" :checked_project_ids="checked_project_ids"
                                   v-on:update-finished="massUpdateFinished"></master-client>
                </div>
                <div class="hidden md:inline w-1/3 text-right">
                    <button class="hidden xl:inline border-2 border-teal bg-teal font-semibold p-2 rounded-full text-white text-sm"
                            @click="show_advanced_search = !show_advanced_search" dusk="advanced-search-button">
                        Advanced Search
                    </button>
                    <button
                        class="hidden xl:inline border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white p-2 rounded-full text-sm text-followup-nav"
                        @click="clearSearch">
                        Clear Search
                    </button>
                </div>
            </div>
            <div v-show="show_advanced_search">
                <pm-advanced-search ref="advancedSearchModule" :user-legacy="userLegacy" v-on:execute="fetchProjects" :masks="masks" :selects="selects" :field-labels="fieldLabels"></pm-advanced-search>
            </div>
            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider changing your search
                    or creating a new project.
                </div>
            </div>
            <div v-if="projects.length > 0" class="bg-white shadow-md rounded mb-6 mt-4">
                <table class="text-left w-full border-collapse" id="project_index">
                    <thead>
                    <tr>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light text-center">
                            <input type="checkbox" class="bg-teal" v-model="check_all" @click="checkAll">
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light whitespace-no-wrap hidden md:table-cell">
                            ID
                        </th>
                        <th v-if="userLegacy" class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light whitespace-no-wrap hidden lg:table-cell"
                            title="Legacy ID">
                            L-ID
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light">
                            Project Name
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-boldco uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Address
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-boldco uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            City
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light">
                            Contact
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Superintendent
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Project Manager
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Project Admin
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Crew / Sub
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Project Engineer
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Project Stage
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Project Duration
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Est. Complete
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            Actual Complete
                        </th>
                        <th class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xxs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                            PM Contract Date
                        </th>
                        <th class="bg-grey-lightest border-b border-grey-light hidden xl:table-cell"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr @click.prevent="editProject(project)" class="hover:bg-grey-lighter cursor-pointer"
                        v-for="project in projects">
                        <td @click.stop="() => null"
                            class="px-1 py-2 py-lg-0 border-b border-grey-light text-xxs cursor-default">
                            <input type="checkbox" class="bg-teal" v-model="project.checked"
                                   :id="'projectCheckbox' + project.id" :name="'projectCheckbox' + project.id"
                                   @click.stop="checkProject(project)">
                        </td>
                        <td class="pl-2 border-b border-grey-light text-xxs hidden md:table-cell">
                            {{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}
                        </td>
                        <td v-if="userLegacy" class="pl-2 border-b border-grey-light text-xxs whitespace-no-wrap hidden lg:table-cell">
                            {{ project.legacy_id }}
                        </td>
                        <td class="pl-2 border-b border-grey-light text-xxs">
                            {{ project.name }}
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.address }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.city }}</div>
                        </td>
                        <td class="pl-2 border-b border-grey-light text-xxs">
                            {{ project.contact ? project.contact.name : '' }}
                        </td>
                        <td class="pl-2 border-b border-grey-light text-xxs">
                            {{ project.superintendent ? project.superintendent.name : '' }}
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.project_manager ? project.project_manager.name : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.project_admin ? project.project_admin.name : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.crew_leader ? project.crew_leader.name : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.project_engineer ? project.project_engineer.name : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.project_stage ? project.project_stage.short_description : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.project_duration ? project.project_duration.short_description : '' }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.complete_date }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.actual_completed_date }}</div>
                        </td>
                        <td class="pl-4 border-b border-grey-light text-xxs hidden lg:table-cell">
                            <div>{{ project.pm_contract_date }}</div>
                        </td>
                        <td class="px-4 border-b border-grey-light text-right hidden xl:table-cell">
                            <span class="material-icons">chevron_right</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-10 text-center">
            <div class="flex-col">
                <div>
                    <img width="400" src="images/empty.svg">
                </div>
                <div v-if="companyExists" class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You haven't added a project yet!</div>
                    </div>
                    <button @click="addProject"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first project!
                    </button>
                </div>
                <div v-else class="mt-4">
                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">
                        <div class="text-xl w-1/4 tracking-wide">You must add a company before adding a project.</div>
                    </div>
                    <button @click="addCompany"
                            class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">
                        Click here to add your first company!
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'project-index',

        props: ['companyExists', 'userLegacy','masks','fieldLabels'],

        data() {
            return {
                projects              : '',
                companies             : '',
                filter                : {
                    project_name: '',
                    advanced    : false,
                },
                page                  : 1,
                pagination            : {
                    data : [],
                    meta : {},
                    links: {},
                },
                data_loading          : true,
                zero_search_results   : false,
                show_advanced_search  : false,
                current_search_pattern: '',
                check_all             : false,
                checked_project_ids   : [],
                selects: {
                    sales_status: [],
                    marketing_status: [],
                    lead_from: [],
                    users: [],
                    products_and_services: [],
                    client_profile: [],
                    contract_type: [],
                    office: [],
                    decision_process: [],
                    find_problems: [],
                    money_step: [],
                    pm_users: [],
                    relate_connect: [],
                    rules_of_engagement: [],
                    project_durations: [],
                    project_stages: [],
                },
            }
        },

        created() {
            this.fetchData();
            this.fetchCodes();
        },

        methods: {
            fetchCodes() {
                const self  = this;
                axios.get(route('api.project.codes')).then(({data}) => {
                    self.selects = data;
                    console.log('this.selects',self.selects)
                });
            },

            goToPage(page) {
                this.page = page;
                this.fetchData();
            },

            fetchData() {
                let filter = null;

                if (localStorage.getItem('last_search')) filter = JSON.parse(localStorage.getItem('last_search'));

                this.fetchProjects(filter);
            },

            fetchProjects(filter = null) {
                if (filter) {
                    this.current_search_pattern = filter;

                    this.filter.project_name = '';
                    localStorage.setItem('last_name_search', '');
                }

                this.show_advanced_search = false;
                let params                = {
                    filter: filter ? filter : {
                        ...this.filter,
                        project_name: this.filter.project_name ?
                            this.filter.project_name :
                            localStorage.getItem('last_name_search')
                    },
                    page  : this.page
                };

                this.data_loading = true;
                axios.get(route('api.project-management.index'), {params}).then(({data}) => {
                    this.projects            = data.data;
                    this.pagination          = data;
                    this.data_loading        = false;
                    this.zero_search_results = (this.filter && this.projects.length === 0);

                    this.fetchFullCurrentList(params);
                });
            },

            fetchFullCurrentList(params) {
                axios.get(route('api.project-management.full-current-list'), {params}).then(({data}) => {
                    localStorage.setItem('current_project_list_project_management', JSON.stringify({data}));
                })
            },

            debounceFilter: _.debounce(function (e) {
                this.filter.project_name = e.target.value;
                localStorage.setItem('last_name_search', e.target.value);

                this.$refs.advancedSearchModule.clear();
                this.goToPage(1)
            }, 700),

            editProject(project) {
                window.location = route('project-management.project.edit', {projectManagement: project.id});
            },

            addProject() {
                window.location = route('project-management.project.create');
            },

            addCompany() {
                window.location = route('project-management.company.create');
            },

            saveSearchPatternModal() {
                this.$refs.savePatternModal.open(this.current_search_pattern);
            },

            useSavedSearchPatternModal() {
                this.$refs.usePatternModal.open();
            },

            clearSearch() {
                this.$refs.advancedSearchModule.clear();

                this.filter.project_name = '';
                localStorage.setItem('last_name_search', '');

                this.clearChecked();
                this.fetchData();
            },

            checkAll() {
                this.check_all = !this.check_all;

                _.forEach(this.projects, project => {
                    project.checked = this.check_all;
                    this.checkedProjectList(project.checked, project.id);
                });
            },

            clearChecked() {
                this.check_all           = false;
                this.checked_project_ids = [];
            },

            checkProject(project) {
                document.getElementById(`projectCheckbox${project.id}`).checked = project.checked ? false : true;
                this.checkedProjectList(project.checked ? false : true, project.id);
            },

            checkedProjectList(checked, id) {
                if (checked) {
                    this.checked_project_ids.push(id);
                    return;
                }
                this.checked_project_ids.splice(
                    this.checked_project_ids.indexOf(id), 1
                );
            },

            updateAssignedUsersModal() {
                if (this.checked_project_ids.length) {
                    this.$refs.updateAssignedUsersModal.open();
                    return;
                }
                this.noProjectsCheckedAlert();
            },

            updateMasterClientModal() {
                if (this.checked_project_ids.length) {
                    this.$refs.updateMasterClientModal.open();
                    return;
                }
                this.noProjectsCheckedAlert();
            },

            massUpdateFinished(data) {
                this.clearChecked();
                this.fetchData();

                Swal.fire({
                    title             : 'Success!',
                    text              : data.message,
                    type              : 'success',
                    showCancelButton  : false,
                    confirmButtonColor: '#17252A',
                    confirmButtonText : 'OK!',
                    closeOnConfirm    : true,
                });
            },

            noProjectsCheckedAlert() {
                Swal.fire({
                    title             : 'No projects selected!',
                    text              : "First, select the projects you want to update.",
                    type              : 'error',
                    showCancelButton  : false,
                    confirmButtonColor: '#17252A',
                    confirmButtonText : 'OK!',
                    closeOnConfirm    : true,
                });
            }
        }
    }
</script>

<style>
    .pagination > li > a {
        color: #4dc0b5;
    }

    .pagination > li > a:hover {
        background-color: #4dc0b5 !important;
        color: white;
    }

    li.page-item.active > a {
        background-color: #4dc0b5 !important;
        border-color: #4dc0b5 !important;
    }

    a.page-link:focus {
        box-shadow: none;
    }
</style>
